/*
 * @Author: 神农西瓜
 * @Date: 2021-05-12 20:40:48
 * @LastEditTime: 2021-11-30 13:59:48
 * @LastEditors: 神农西瓜
 * @Description: 
 * @FilePath: /otherFiles/STO_ERP/src/config/global.js
 */
let APP_ID; // 飞书自建程序appid
let SERVER; // 线上地址
let BASE_URL; // api地址
let REDIRECT_URI; // 飞书登陆回调url
let APP_LINK_FLAG; // 是否开启飞书 AppLink 跳转
const FEISHU_CALLBACK = "/api/auth/getUserInfo2";

// 判断当前是否为生产环境
const DEFAULT_HOST = "https://sys.yksto.com";
if (process.env.VUE_APP_TITLE == "production") {
  APP_ID = "cli_a8e8d93071b1901c";
  SERVER = DEFAULT_HOST;
  BASE_URL = `${DEFAULT_HOST}/`;
  REDIRECT_URI = `${DEFAULT_HOST}${FEISHU_CALLBACK}`;
  APP_LINK_FLAG = false;
} else if (process.env.VUE_APP_TITLE == "test") {
  APP_ID = "cli_a8e8d93071b1901c";
  SERVER = DEFAULT_HOST;
  BASE_URL = `${DEFAULT_HOST}/`;
  REDIRECT_URI = `${DEFAULT_HOST}${FEISHU_CALLBACK}`;
  APP_LINK_FLAG = false;
} else {
  APP_ID = "cli_a8e8d93071b1901c";
  SERVER = DEFAULT_HOST;
  BASE_URL = `${DEFAULT_HOST}/`;
  REDIRECT_URI = `${DEFAULT_HOST}${FEISHU_CALLBACK}`;
  APP_LINK_FLAG = false;
}

export { SERVER, BASE_URL, REDIRECT_URI, APP_LINK_FLAG, APP_ID };
